import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-founder-msg',
  templateUrl: './founder-msg.component.html',
  styleUrls: ['./founder-msg.component.scss']
})
export class FounderMsgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
